import React, {useState} from 'react'
import {View, StyleSheet, Text, TextInput} from 'react-native'

const RoundTextInput = ({ value = '', placeholder = 'Placeholder', name, error = false, errorString = 'Error', onChangeText, onPress, style, textStyle, ...props}) => {
  if(name === undefined) {
    name = placeholder;
  }
  return (
    <View
      style={{
        marginBottom: 16
      }}
    >
      <View
        style={{
          borderWidth: 1,
          borderColor: error ? '#F09696' : (value.length > 0 ? '#AFABAC' : '#8692A6'),
          borderRadius: 8,
          backgroundColor: 'white',
          paddingHorizontal: 16,
          paddingVertical: 8,
          minHeight: 60,
          justifyContent: 'center'
        }}
      >
        <Text
          style={{
            textTransform: 'uppercase',
            fontWeight: '500',
            fontSize: 12,
            color: error ? '#B96363' : (value.length > 0 ? '#096730' : '#8692A6'),
          }}
        >{name}</Text>
        <TextInput
          style={{
            marginTop: 8,
            fontWeight: '400',
            fontSize: 16,
            color: 'black',
            outline: 'none'
          }}
          placeholder={placeholder}
          onChangeText={onChangeText}
          placeholderTextColor={'gray'}
          autoCapitalize="words"
          underlineColorAndroid="rgba(0,0,0,0)"
          value={value}
          {...props}
        />
      </View>
      {error && <Text
        style={{
          color: '#B96363',
          marginTop: 4,
          marginLeft: 16
        }}
      >{errorString}</Text>}
    </View>

  )
}

export default RoundTextInput
